module.exports = __webpack_public_path__ + "static/media/testimonial_bg_new.4661469d.jpg";